import React, { useContext } from 'react';
import { MainContext } from '../context/main.context';
import { Navigate } from 'react-router-dom';
import { checkAuth } from '../stores/auth.store';
import { CHECK_AUTH_ERROR } from '../common/errorCodes';
import ManualController from './ManualController';


export default function Protected({ children }: any): React.JSX.Element {
    const { userAuthData, jwt } = useContext(MainContext);
    const { manualRedirect } = ManualController();

    if (userAuthData) {
        return <Navigate to="/" replace/>;
    }

    if (jwt) {
        checkAuth(jwt).then(res => {
            const result = res?.data?.result;
            const type: 'authExist'|'authNotExist' = result ? 'authExist' : 'authNotExist';

            manualRedirect({}, type);
            return;
        }, err => {
            const errData = err?.response?.data || err;

            manualRedirect(errData, 'auth', true, CHECK_AUTH_ERROR);
        });
    }

    return children;
};